import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaThLarge, FaClipboardList, FaRegBell, FaExclamationTriangle, FaChartBar, FaFileDownload } from 'react-icons/fa';
import './DashboardNav.css';

const DashboardNav = () => {
  const location = useLocation();

  return (
    <nav className="dashboard-nav">
      <Link to="/dashboard" className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}>
        <FaThLarge />
        <span>Overview</span>
      </Link>
      <Link to="/approval-requests" className={`nav-item ${location.pathname === '/approval-requests' ? 'active' : ''}`}>
        <FaClipboardList />
        <span>Approval Request</span>
      </Link>
      <Link to="/attendance-log" className={`nav-item ${location.pathname === '/attendance-log' ? 'active' : ''}`}>
        <FaRegBell />
        <span>Attendance Log</span>
      </Link>
      <Link to="/attendance-reports" className={`nav-item ${location.pathname === '/attendance-reports' ? 'active' : ''}`}>
        <FaFileDownload />
        <span>Reports</span>
      </Link>
      <Link to="/student-meter" className={`nav-item ${location.pathname === '/student-meter' ? 'active' : ''}`}>
        <FaChartBar />
        <span>Student Meter</span>
      </Link>
      <Link to="/sos-alerts" className={`nav-item sos-alert ${location.pathname === '/sos-alerts' ? 'active' : ''}`}>
        <FaExclamationTriangle />
        <span>SOS Alerts</span>
      </Link>
    </nav>
  );
};

export default DashboardNav;
